import { useEffect, useState } from 'react'

/**
 * Catch-all page that renders the existing SPA.
 * This is a client-only page — the existing react-router-dom SPA hydrates here.
 * During SSR migration, individual routes will be extracted to their own Vike pages.
 */
export default function SpaShellPage() {
  const [SpaApp, setSpaApp] = useState<React.ComponentType | null>(null)

  useEffect(() => {
    // Dynamically import the SPA to avoid SSR issues with react-router-dom's BrowserRouter
    import('../../src/SpaApp').then((mod) => {
      setSpaApp(() => mod.default)
    })
  }, [])

  if (!SpaApp) {
    return <div id="root"></div>
  }

  return <SpaApp />
}
